import React from 'react';
import Zoom from 'react-reveal/Zoom';

const DashboardHome = () => {
    return (
        <Zoom>
            <div>
                <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=815&q=80" alt="" width="100%" height="100%" />
            </div>
        </Zoom>
    );
};

export default DashboardHome;